export default "__VITE_ASSET__Cg4tIlgA__"